{
  "replaceMessage": "Déposer le fichier à remplacer"
}
